import { Pipe, PipeTransform } from '@angular/core';
import { AuftragListEntryMeta } from '../../../core/auftrag-api';

@Pipe({
  name: 'auftragsNummer'
})
export class AuftragsNummerPipe implements PipeTransform {
  transform(entry: AuftragListEntryMeta, args?: any): any {
    if (!entry) {
      return '';
    }
    if (entry.erstellAmt && entry.auftragNummer) {
      return entry.erstellAmt + '-' + entry.auftragNummer;
    }
    if (entry.auftragNummer) {
      return entry.auftragNummer;
    }
    return '';
  }
}
